import { render, staticRenderFns } from "./iconLastName.vue?vue&type=template&id=a6febbf8"
import script from "./iconLastName.vue?vue&type=script&lang=js"
export * from "./iconLastName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports